import React from 'react';
import CreateRequestComponent from '@websky/core/src/Modules/Exchange/components/Exchange/CreateRequest/CreateRequest';
const CreateRequest = props => {
    return React.createElement(CreateRequestComponent, Object.assign({}, props, { isRulesOptional: true }));
};
export default CreateRequest;
